import { render, staticRenderFns } from "./zzgl.vue?vue&type=template&id=36d3910d&scoped=true"
import script from "./zzgl.vue?vue&type=script&lang=js"
export * from "./zzgl.vue?vue&type=script&lang=js"
import style0 from "./zzgl.vue?vue&type=style&index=0&id=36d3910d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3910d",
  null
  
)

export default component.exports